export var CHAT_LOCAL_STORAGE_KEY = "arthur-chat-state";
//# sourceMappingURL=chat-local-storage.js.map